import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";
import "./BreadCrumb.scss";

/**
 * Normalizes crumbs so internal `url` values use SPA navigation (command + no href)
 * instead of full page reloads. External URLs are left intact. Existing commands
 * are preserved (but wrapped to prevent default).
 */
function normalizeCrumbsForSpa(crumbs, navigate) {
  if (!crumbs?.length || !navigate) return crumbs;
  return crumbs.map((item) => {
    const url = item?.url;
    const isInternalUrl = typeof url === "string" && url.startsWith("/");

    if (item.command) {
      return {
        ...item,
        command: (event) => {
          event?.originalEvent?.preventDefault?.();
          item.command(event);
        },
      };
    }

    if (isInternalUrl) {
      return {
        ...item,
        url: undefined,
        command: (event) => {
          event?.originalEvent?.preventDefault?.();
          navigate(url);
        },
      };
    }

    return item;
  });
}

export default function BreadCrumbs({ crumbs }) {
  const navigate = useNavigate();
  const model = useMemo(
    () => normalizeCrumbsForSpa(crumbs, navigate),
    [crumbs, navigate],
  );

  return model?.length ? (
    <div className="bread-crumb-nav mb-4">
      <BreadCrumb model={model} />
    </div>
  ) : null;
}
